import thirPartPayBg from "../../../assets/image/store/cloudThirdBg.png"; 
import thirPartPayBg2 from "../../../assets/image/store/cloudThirdBg2.png"; 
import selectThirPay from "../../../assets/image/store/selectThirPayCloud.png"; 
import selectInnerPay from "../../../assets/image/store/selectThirPayCloud2.png"; 
import whiteProductSwitchBtn from "../../../assets/image/store/white-product-change.png"; 
import triangleDown from "../../../assets/image/icons/triangle-down-cloud.png"; 
import more from "../../../assets/image/icons/cloud-more.png"; 
import whiteMall from "../../../assets/image/store/cloud-mall-icon.png"; 
import cloudShopingCar from "../../../assets/image/store/cloudShoppingCart.png"; 
import cloudMoney from "../../../assets/image/store/cloudMoney.png"; 
import payFailBg from "../../../assets/image/store/result-type-wrapper-red-cloud.png"; 
import paySuccessBg from "../../../assets/image/store/result-type-wrapper-cloud.png"; 
import paySuccess from "../../../assets/image/store/paySuccess-cloud.png"; 
import payStoring from "../../../assets/image/store/pay_storing_cloud.png"; 
import payFail from "../../../assets/image/store/cloudPayFail.png"; 
import playGameIcon from "../../../assets/image/icons/playGame.png"; 
import serviceIcon from "../../../assets/image/icons/service-cloud.png"; 
import switchIcon from "../../../assets/image/icons/switch-cloud.png"; 
import loadding from "../../../assets/image/icons/cloudLoadding.png"; 
import bindIcon from "../../../assets/image/icons/bindIcon_cloud.png"; 
import userIcon from "../../../assets/image/icons/user-icon-cloud.png"; 
import ellipsisIcon from "../../../assets/image/icons/feedback-icon-cloud.png"; 
import textIcon from "../../../assets/image/icons/text-icon-cloud.png"; 
import accountFollowIcon from "../../../assets/image/icons/account-follow.png"; 
import exchangeIcon from "../../../assets/image/icons/exchange-icon_cloud.png"; 
import fundTermsIcon from "../../../assets/image/icons/fund-terms_cloud.png"; 
import survey from "../../../assets/image/icons/survey-cloud.png"; 
import deleteIcon from "../../../assets/image/icons/delete-cloud.png"; 
import settingIcon from "../../../assets/image/icons/setting-icon-blue.png"; 
import selectHili from "../../../assets/image/icons/selectHili-cloud.png"; 
import closeBtn from "../../../assets/image/icons/closeBtn-cloud.png"; 
import dialogCloudBg from "../../../assets/image/icons/cloudBg.png"; 
import loginBg from "../../../assets/image/webLogin/loginBgYun.png"; 
import userName from "../../../assets/image/icons/userName-brown.png"; 
import password from "../../../assets/image/icons/password-brown.png"; 
import cloudStar from "../../../assets/image/support/cloudStar.png"; 
import cloudStarActive from "../../../assets/image/support/cloudStarActive.png"; 
import serviceDefaultAvatar from "../../../assets/image/support/potrait-service-blue.png"; 
import userDefaultAvatar from "../../../assets/image/support/potrait-user-cloud.png"; 
import userInfoDefaultAvatar from "../../../assets/image/support/user-avatar-blue.png"; 
import inputBg from "../../../assets/image/webLogin/inputBg.png"; 
import loginBtn from "../../../assets/image/webLogin/login-btn.png"; 
import regBtn from "../../../assets/image/webLogin/reg-btn.png"; 
import loginAccountBg from "../../../assets/image/webLogin/login-account-bg2.png"; 
import submitOrderBtn from "../../../assets/image/store/submit-order-btn.png"; 
import leftImg from "../../../assets/image/store/left.png"; 
import rightImg from "../../../assets/image/store/right.png"; 
import middleImg from "../../../assets/image/store/middle.png"; 
import restoreLeftImg from "../../../assets/image/store/kong-left.png"; 
import restoreRightImg from "../../../assets/image/store/kong-right.png"; 
import restoreMiddleImg from "../../../assets/image/store/kong-middle.png"; 
import returnGameLeftImg from "../../../assets/image/store/returnGameLeft.png"; 
import returnGameRightImg from "../../../assets/image/store/returnGameRight.png"; 
import returnGameMiddleImg from "../../../assets/image/store/returnGameMiddle.png"; 
import switchAccountLeftImg from "../../../assets/image/passport/switchAccountLeft.png"; 
import switchAccountRightImg from "../../../assets/image/passport/switchAccountRight.png"; 
import switchAccountMiddleImg from "../../../assets/image/passport/switchAccountMiddle.png"; 
import commonBtnLeftImg from "../../../assets/image/passport/commonBtnLeft.png"; 
import commonBtnRightImg from "../../../assets/image/passport/commonBtnRight.png"; 
import commonBtnMiddleImg from "../../../assets/image/passport/commonBtnMiddle.png"; 
import tinyCheckIcon from "../../../assets/image/support/tiny-check-icon-cloud.png"; 
import createWorkLeftImg from "../../../assets/image/support/btn-left.png"; 
import createWorkRightImg from "../../../assets/image/support/btn-right.png"; 
import createWorkMiddleImg from "../../../assets/image/support/btn-middle.png"; 
import editBtn from "../../../assets/image/support/edit.png"; 
import resultBackLeftImg from "../../../assets/image/support/resultBtnLeft.png"; 
import resultBackRightImg from "../../../assets/image/support/resultBtnRight.png"; 
import resultBackMiddleImg from "../../../assets/image/support/resultBtnMiddle.png"; 
import resultHistoryLeftImg from "../../../assets/image/support/historyBtnLeft.png"; 
import resultHistoryRightImg from "../../../assets/image/support/historyBtnRight.png"; 
import resultHistoryMiddleImg from "../../../assets/image/support/historyBtnMiddle.png"; 
import selectPayTypeBtn from "../../../assets/image/store/selectPayTypeBtn.png"; 
import selectPayTypeBtn2 from "../../../assets/image/store/selectPayTypeBtn2.png"; 
import loginBoxLeftTop from "../../../assets/image/icons/lefttop.png"; 
import loginBoxRightTop from "../../../assets/image/icons/righttop.png"; 
import loginBoxLeftBottom from "../../../assets/image/icons/leftbottom.png"; 
import loginBoxRightBottom from "../../../assets/image/icons/rightbottom.png"; 
import loginBtnLeftImg from "../../../assets/image/webLogin/loginBtnLeft.png"; 
import loginBtnRightImg from "../../../assets/image/webLogin/loginBtnRight.png"; 
import loginBtnMiddleImg from "../../../assets/image/webLogin/loginBtnMiddle.png"; 
import loginBtnLeftImg2 from "../../../assets/image/webLogin/loginBtnLeft2.png"; 
import loginBtnRightImg2 from "../../../assets/image/webLogin/loginBtnRight2.png"; 
import loginBtnMiddleImg2 from "../../../assets/image/webLogin/loginBtnMiddle2.png"; 
import shortCancel from "../../../assets/image/passport/shortCancel.png"; 
import shortConfirm from "../../../assets/image/passport/shortConfirm.png"; 
import supportSearchIcon from "../../../assets/image/support/search.png"; 
let $inputCorlor = 'yellow'
let $lightBlue = '#c0dfff'
let $middleBrown = '#5a3823'
let $headerBg = '#eadfbf'
let $testBorder = `1px solid ${$headerBg}`
let $selectTriggerBtn = {
  'border' : '1px solid #7c573f',
  'color' : $middleBrown,
  'padding' : '0 10px'
}
let $dialogScale = 550 / 736
let $dialogcloudBgStyles = {
  'background-image' : `url( ${dialogCloudBg})`,
  'background-repeat' : 'no-repeat',
  'background-position' : '67px 120px',
  'background-size' : '80%'
}
let $storePayBtn = {
  'width' : '16px',
  'height' : '17px',
  'position' : 'absolute',
  'right' : '50px',
  'top' : '50%',
  'transform' : 'translateY(-50%)'
}
let $selectPayType = {
  'width' : '249px',
  'height' : '61px',
  'line-height' : '61px',
  'background-color' : 'transparent',
  'border-radius' : '0',
  'color' : '#834817',
  'font-weight' : 'bold'
}
let $passportFunctionIconStyles = {
  'background-repeat' : 'no-repeat',
  'width' : '78px',
  'height' : '95px',
  'left' : '0',
  'background-position' : 'center center',
  'background-size' : 'auto !important'
}
let $activeListItem = {
  'border' : `1px solid ${$middleBrown}`,
  'color' : $middleBrown,
  'border-width' : '2px'
}
let $fillBtnVh = {
  'display' : 'block',
  'width' : '89.9%',
  'height' : '60px',
  'background-image' : `url( ${loginBtnMiddleImg})`,
  'background-size' : 'contain',
  'background-repeat' : 'repeat',
  'margin-left' : '23px',
  'line-height' : '60px',
  'font-size' : '3vh',
  'background-color' : 'transparent',
  'border-radius' : '0',
  'color' : $middleBrown,
  'overflow' : 'visible',
  'margin-left' : 'auto',
  'margin-right' : 'auto'
}

let $noRpBg = function($img){ 
  return {
  'background-image' : `url( ${$img})`,
  'background-repeat' : 'no-repeat'
  }

}

  export default {
'vlink' : { 

 typeTheme :{ 
 'repaireAccountBtn' : { 
  'background-color' : '#c0dfff'
 
}} 
}
,
'button' : { 
  commonTheme : {
  'border-radius' : '30px',
  'font-size' : '32px',
  'height' : '60px',
  'line-height' : '60px',
  'color' : 'white',
  'background-color' : $lightBlue,
  'border' : '0',
  'cursor' : 'pointer'
  },
 typeTheme :{ 
 'repaireAccountApplyBtn' : { 
  'height' : '40px',
  'line-height' : '40px',
  'width' : '288px',
  'margin' : '50px auto 0',
  'font-size' : '18px',
  'color' : '#fff',
  'background-color' : '#c0dfff'
 
},
 'repaireAccountQueryBtn' : { 
  'height' : '40px',
  'line-height' : '40px',
  'width' : '288px',
  'margin' : '50px auto 0',
  'font-size' : '18px',
  'color' : '#fff',
  'background-color' : '#c0dfff'
 
},
 'markScoreMainClose' : { 
  'height' : '24px',
  'background-color' : 'transparent',
  'background-image' : 'url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAAaCAYAAACpSkzOAAABLElEQVRIia3TIU4DQRQG4I8JqjfAIsDV4GqgFooChaMJqYaDVEMgdQQDhhRsQcAB6kBwClKN6G7SlO3uzG7/ZMybN/NN8jIbH9eXexhhG8+4wExkOoPhv9rnzVULdzjGD/qbGdLOes6whV4KVoC84CArtTEK2F3q7WKM1hqQPDsBTwVnkrESBB6D+Uzem2AVyASDYD6Lw7pYBNLrDIazkBXqYlEIhIWNVCwaWYZSsCSkCIrFkpBVUAyWhJRBVVgSUgUtYm9NkBhobamCWnhVPJM8XYyzj1sLypH9isdEYaugMmSieGalWBFUhfRwlIotQzHILFtJ2CIUi+RJwnIoFUnGQgMEZB+1Egu4rYskYDcBJ02QSOw04KspEoF9B/QxxS/u6yIF2EN25xTnfz27paEGmZnMAAAAAElFTkSuQmCC)'
 
},
 'createWorkBtn' : { 
  'color' : '#5a3823 !important',
  'border' : 'none',
  'background-image' : `url( ${createWorkMiddleImg})`,
  'width' : '96%',
  'height' : '78px',
  'background-size' : 'contain',
  'background-repeat' : 'repeat',
  'background-color' : 'transparent',
  'margin-left' : '14px',
  'border-radius' : '0'
 
},
 'long' : { 
  'width' : '456px'
 
},
 'short' : { 
  'width' : '300px'
 
},
 'shortWidth' : { 
  'width' : '310px',
  'height' : '60px',
  'color' : '#5a3823 !important',
  'border' : 'none',
  'background-image' : `url( ${createWorkMiddleImg})`,
  'background-size' : 'contain',
  'background-repeat' : 'repeat',
  'background-color' : 'transparent',
  'margin-left' : '-155px',
  'border-radius' : '0'
 
},
 'edit' : { 
  'position' : 'relative',
  'top' : '3px',
  'width' : '151px',
  'height' : '60px',
  'background-image' : `url( ${editBtn})`,
  'border-radius' : '0',
  'background-color' : 'transparent',
  'color' : '#6e5813'
 
},
 'fill' : { 
  'width' : '100%',
  'background-color' : $middleBrown
 
},
 'fillLightDialog' : { 
  'position' : 'relative',
  'height' : '60px',
  'border' : '0',
  'font-size' : '20px',
  'width' : '90%',
  'background-image' : `url( ${commonBtnMiddleImg})`,
  'color' : '#503b0a',
  'font-weight' : 'bold',
  'border-radius' : '0',
  'margin-left' : '-3px'
 
},
 'fillLight' : { 
  'position' : 'relative',
  'height' : '60px',
  'border' : '0',
  'font-size' : '20px',
  'width' : '90%',
  'background-image' : `url( ${commonBtnMiddleImg})`,
  'color' : '#503b0a',
  'font-weight' : 'bold',
  'border-radius' : '0',
  'margin-left' : '26px'
 
},
 'fillLights' : { 
  'position' : 'absolute',
  'height' : '60px',
  'border' : '0',
  'font-size' : '30px',
  'width' : '401px',
  'background-image' : `url( ${commonBtnMiddleImg})`,
  'color' : '#503b0a',
  'font-weight' : 'bold',
  'border-radius' : '0',
  'margin-left' : '-200.5px'
 
},
 'fillLightVh' : { 
  ...$fillBtnVh
 
},
 'fillEmtyBorderVh' : { 
  ...$fillBtnVh,
  'margin-top' : '2.3vh',
  'background-image' : `url( ${loginBtnMiddleImg2})`
 
},
 'storeBtn' : { 
  'margin-top' : '24px',
  'color' : '#8a6f18 !important',
  'border' : 'none',
  'background-image' : `url( ${middleImg})`,
  'width' : '95.5%',
  'height' : '78px',
  'background-size' : 'contain',
  'background-repeat' : 'repeat',
  'background-color' : 'transparent',
  'margin-left' : '17px',
  'border-radius' : '0'
 
},
 'refresh' : { 
  'background-color' : '#eadfbf',
  'border-radius' : '0',
  'margin-left' : '0',
  'height' : '72px'
 
},
 'selectResetPwd' : { 
  'width' : '200px',
  'height' : '50px',
  'line-height' : '50px',
  'border-radius' : '0',
  'font-size' : '18px',
  'background-color' : '#eadfbf'
 
},
 'selectPayType' : { 
  ...$selectPayType,
  'background-image' : `url( ${selectPayTypeBtn})`,
  'margin-top' : '32px'
 
},
 'selectInnerWay' : { 
  ...$selectPayType,
  'color' : '#fff',
  'background-image' : `url( ${selectPayTypeBtn2})`
 
},
 'switchProduct' : { 
  'background-image' : `url( ${whiteProductSwitchBtn})`,
  'width' : '56px',
  'height' : '56px',
  'background-color' : 'transparent',
  'border-radius' : '0'
 
},
 'returnGame' : { 
  'color' : '#8a6f18 !important',
  'border' : 'none',
  'background-image' : `url( ${returnGameMiddleImg})`,
  'width' : '100%',
  'height' : '86px',
  'background-size' : 'contain',
  'background-repeat' : 'repeat',
  'background-color' : 'transparent',
  'margin-left' : '0',
  'border-radius' : '0'
 
},
 'reStore' : { 
  'color' : '#5a3823 !important',
  'border' : 'none',
  'background-image' : `url( ${restoreMiddleImg})`,
  'width' : '100%',
  'height' : '86px',
  'background-size' : 'contain',
  'background-repeat' : 'repeat',
  'background-color' : 'transparent',
  'margin-left' : '0',
  'border-radius' : '0'
 
},
 'swtichAccount' : { 
  'min-width' : '160px',
  'height' : '60px',
  'border' : '0',
  'transform' : 'translateY(16px)',
  'padding' : '0 9px',
  'font-size' : '20px',
  'width' : '100%',
  'background-image' : `url( ${switchAccountMiddleImg})`,
  'color' : '#503b0a',
  'font-weight' : 'bold',
  'border-radius' : '0',
  'margin-left' : '26px'
 
},
 'lightfill' : { 
  'position' : 'relative',
  'height' : '60px',
  'border' : '0',
  'font-size' : '20px',
  'width' : '90%',
  'background-image' : `url( ${commonBtnMiddleImg})`,
  'color' : '#503b0a',
  'font-weight' : 'bold',
  'border-radius' : '0',
  'margin-left' : '26px'
 
},
 'closeBtn' : { 
  'width' : '31px',
  'height' : '31px',
  'font-size' : 'initial',
  'background-image' : `url( ${closeBtn})`,
  'background-color' : 'transparent'
 
},
 'shortCancel' : { 
  'background-color' : 'white',
  'border' : 'none',
  'border-radius' : '0',
  'line-height' : '60px',
  'height' : '60px',
  'width' : '228px',
  'color' : '#5a3823',
  'background-image' : `url( ${shortCancel})`,
  'background-color' : 'transparent'
 
},
 'shortConfirm' : { 
  'line-height' : '60px',
  'border' : 'none',
  'height' : '60px',
  'width' : '228px',
  'color' : '#7e6516',
  'border-radius' : '0',
  'background-image' : `url( ${shortConfirm})`,
  'background-color' : 'transparent'
 
},
 'lightShort' : { 
  'font-size' : '24px',
  'background-color' : '#eadfbf'
 
},
 'grayShort' : { 
  'background' : '#ccc'
 
},
 'logoutBtn' : { 
  'background' : 'transparent',
  'height' : '4vh',
  'line-height' : '4vh',
  'font-size' : '1.8vh',
  'color' : '#7a7a7a',
  'padding' : '0',
  'border-radius' : '0',
  'border-bottom' : '1px solid #7a7a7a'
 
},
 'showServiceList' : { 
  'top' : '500px',
  'width' : '310px',
  'height' : '60px',
  'color' : '#5a3823 !important',
  'border' : 'none',
  'background-image' : `url( ${resultHistoryMiddleImg})`,
  'background-size' : 'contain',
  'background-repeat' : 'repeat',
  'background-color' : 'transparent',
  'margin-left' : '-155px',
  'border-radius' : '0'
 
},
 'supportReturnGame' : { 
  'position' : 'absolute',
  'top' : '440px',
  'height' : '60px',
  'border' : '0',
  'font-size' : '30px',
  'width' : '401px',
  'background-image' : `url( ${commonBtnMiddleImg})`,
  'color' : '#503b0a',
  'font-weight' : 'bold',
  'border-radius' : '0',
  'margin-left' : '-200.5px',
  'transform' : 'translate(0)'
 
},
 'bankInvoiceBtn' : { 
  'width' : '90%',
  'background-color' : '#9fc9f5'
 
}} 
}
,
'storeBtn' : { 

 typeTheme :{ 
 'path' : { 
  'stroke' : '#8a6f18'
 
}} 
}
,
'fillLightVh' : { 

 typeTheme :{ 
 'path' : { 
  'stroke' : $middleBrown
 
}} 
}
,
'selectTriggerBtn' : { 
  commonTheme : {
  'height' : '40px',
  'line-height' : '40px',
  'background-color' : 'white'
  },
 typeTheme :{ 
 'locationSelect' : { 
  'border-radius' : '20px',
  ...$selectTriggerBtn
 
},
 'amountSelect' : { 
  ...$selectTriggerBtn,
  'width' : '278px',
  'float' : 'right'
 
},
 'bankSelect' : { 
  'color' : $middleBrown,
  'width' : '60%',
  'height' : '60px',
  'margin' : '0 auto',
  'text-align' : 'center',
  'padding' : '0 10px',
  'border' : `1px solid ${$middleBrown}`
 
}} 
}
,
'title' : { 
  commonTheme : {
  'color' : $middleBrown
  },
 typeTheme :{ 
 'articleTtile' : { 
  'font-size' : '36px'
 
},
 'dialogTitle' : { 
  'font-size' : '40px',
  'color' : '#414141',
  'margin-top' : '44px',
  'margin-bottom' : '33px'
 
},
 'switchTitle' : { 
  'font-size' : '40px',
  'color' : '#414141',
  'margin-top' : '60px',
  'margin-bottom' : '40px'
 
}} 
}
,
'headerContainer' : { 
  commonTheme : {
  'background' : $headerBg,
  'color' : '#664833',
  'font-weight' : 'bold'
  }}
,
'footerContainer' : { 
  commonTheme : {
  'padding-top' : '32px',
  'background' : $headerBg
  },
 typeTheme :{ 
 'supportFooter' : { 
  'height' : '130px'
 
}} 
}
,
'SelectGroup' : { 
  commonTheme : {
  'color' : $middleBrown,
  'border' : 'solid 1px #c59871',
  'border-radius' : '20px',
  'background' : 'white',
  'top' : '25px'
  },
 typeTheme :{ 
 'selectStoreInfo' : { 
  'width' : '100%',
  'height' : '4.1vh',
  'border-radius' : '0',
  'padding' : '0 2vh',
  'margin-bottom' : '1.7vh',
  'margin-left' : '0',
  'top' : '0',
  'box-sizing' : 'border-box'
 
}} 
}
,
'select' : { 
  commonTheme : {
  'color' : $middleBrown,
  'border' : 'solid 1px #c59871',
  'border-radius' : '20px',
  'background' : 'white',
  'top' : '25px'
  },
 typeTheme :{ 
 'selectStoreInfo' : { 
  'width' : '100%',
  'height' : '4.1vh',
  'border-radius' : '0',
  'padding' : '0 2vh',
  'margin-bottom' : '1.7vh',
  'margin-left' : '0',
  'top' : '0',
  'box-sizing' : 'border-box'
 
},
 'selectLang' : { 
  'font-size' : '18px',
  'margin-right' : '3vh',
  'top' : '0'
 
},
 'selectLangLogin' : { 
  'margin-right' : '3vh',
  'top' : '-6vh'
 
}} 
}
,
'block' : { 

 typeTheme :{ 
 'accountBox' : { 
  'overflow' : 'visible'
 
},
 'loginBoxBorder' : { 
  'position' : 'absolute',
  'width' : '100%',
  'height' : '100%',
  'border' : '2px solid #e0d2a7',
  'top' : '0',
  'left' : '0'
 
},
 'payWayBtn' : { 
  'border' : `1px solid ${$middleBrown}`
 
},
 'line' : { 
  'background' : '#ac9b91'
 
},
 'price' : { 
  'background' : '#edd075'
 
},
 'storeOrder' : { 
  'background' : '#eadfbf',
  'color' : '#5a3823',
  'font-width' : 'bold'
 
},
 'pageContainer' : { 
  'background' : '#fff'
 
},
 'storeOrderBorder' : { 
  'border-bottom' : '1px solid #c3d3da'
 
},
 'funtionListItem' : { 
  'border-bottom' : '1px solid #f2ebd9',
  'display' : 'flex',
  'align-items' : 'center',
  'margin-bottom' : '0',
  'color' : '#5a3823',
  'font-size' : '33px'
 
},
 'passportHeader' : { 
  'background' : 'white',
  'box-shadow' : '1px 10px 10px #ebdccf',
  'margin-bottom' : '0',
  'position' : 'relative',
  'z-index' : '2',
  'color' : '#5a3823'
 
},
 'accountDialog' : { 
  ...$dialogcloudBgStyles,
  'border-radius' : '12px'
 
},
 'accountDialogContainer' : { 
  'background-color' : 'transparent',
  'height' : `${$dialogScale} * 476 + px`
 
},
 'tipsDialogWrapper' : { 
  ...$dialogcloudBgStyles,
  'background-color' : 'transparent'
 
},
 'loginTipsDialogWrapper' : { 
  ...$dialogcloudBgStyles,
  'background-color' : 'white',
  'border-radius' : '1.2vh',
  'border' : '0',
  'padding' : '1.4vh 1.5vh'
 
},
 'dialogBtnDocker' : { 
  'margin-bottom' : '20px'
 
},
 'tipsDialog' : { 
  'border-radius' : '12px'
 
},
 'accountSetting' : { 
  'background' : 'white',
  'padding-top' : '15px'
 
},
 'editorWrapper' : { 
  'background' : 'transparent'
 
},
 'countDown' : { 
  'background' : 'transparent',
  'display' : 'flex',
  'align-items' : 'center',
  'font-size' : '20px'
 
},
 'activeListItem' : { 
  'border' : '1px solid #c59871',
  'color' : '#a17449',
  'border-width' : '2px'
 
},
 'webLogin' : { 
  'background-image' : `url( ${loginBg})`,
  'background-position' : '50% 27px',
  'background-color' : '#eadfbf'
 
},
 'loginBox' : { 
  'box-shadow' : '0 10px 10px #e0d2a7',
  'background-size' : '100% 100%',
  'background-repeat' : 'no-repeat',
  'background-color' : '#fff'
 
},
 'gameSelectBox' : { 
  'background-color' : 'transparent'
 
},
 'gameSelectBoxStore' : { 
  'background-color' : 'transparent'
 
},
 'serviceSuccessPopup' : { 
  'border' : '0',
  'border-radius' : '1',
  ...$dialogcloudBgStyles,
  'height' : '600px',
  'border-color' : 'white',
  'background-color' : '#fff'
 
},
 'scoreBlock' : { 
  'width' : '591px',
  'height' : '568px',
  'background-color' : 'white',
  'background-image' : `url( ${dialogCloudBg})`,
  'background-repeat' : 'no-repeat',
  'border-radius' : '0',
  'background-position' : '67px 121px'
 
},
 'maintainScoreImg' : { 
  'display' : 'block',
  'width' : '158px',
  'height' : '158px',
  'margin' : '80px auto 20px auto',
  'background-image' : `url( ${paySuccess})`,
  'background-repeat' : 'no-repeat',
  'background-size' : 'cover'
 
},
 'scoreStartContainer' : { 
  'top' : '180px'
 
},
 'commentTips' : { 
  'top' : '250px'
 
},
 'loadding' : { 
  'background-image' : `url( ${loadding})`
 
},
 'lastFuntionListItem' : { 
  'color' : '#5a3823',
  'font-size' : '33px'
 
}} 
}
,
'blockClickable' : { 

 typeTheme :{ 
 'payWayDetail' : { 
  'border' : '1px solid #c59871'
 
},
 'moreGameText' : { 
  'color' : $middleBrown
 
},
 'bankWayDetail' : { 
  'border' : `1px solid ${$middleBrown}`,
  'padding-right' : '30px',
  'flex-wrap' : 'wrap',
  'height' : 'auto'
 
}} 
}
,
'add' : { 
  commonTheme : {
  'background-image' : 'url(data:image/png;base64,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);'
  }}
,
'content' : { 

 typeTheme :{ 
 'tipsContent' : { 
  'font-size' : '20px'
 
},
 'passportTips' : { 
  'border-bottom' : '1px solid #d5d5d5'
 
}} 
}
,
'mark' : { 
  commonTheme : {
  'color' : $middleBrown,
  'text-decoration' : 'underline'
  },
 typeTheme :{ 
 'contactService' : { 
  'color' : '#a9371c'
 
},
 'thirdPartName' : { 
  'color' : '#a33619',
  'text-decoration' : 'none',
  'font-size' : '36px',
  'font-weight' : 'bold'
 
},
 'amount' : { 
  'color' : '#a23722',
  'text-decoration' : 'none'
 
},
 'coinName' : { 
  'color' : '#5a3823',
  'text-decoration' : 'none'
 
}} 
}
,
'supportReplyInput' : { 
  commonTheme : {
  'width' : '70%',
  'background-color' : 'white',
  'margin-right' : '35px',
  'height' : '60px',
  'line-height' : '60px'
  }}
,
'icon' : { 

 typeTheme :{ 
 'searchType' : { 
  'background-image' : `url( ${supportSearchIcon})`,
  'width' : '25px',
  'height' : '26px'
 
},
 'commonHeaderBack' : { 
  'top' : '33px'
 
},
 'loginBoxLeftTop' : { 
  'position' : 'absolute',
  'background-image' : `url( ${loginBoxLeftTop})`,
  'top' : '7px',
  'left' : '7px',
  'width' : '46px',
  'height' : '46px'
 
},
 'loginBoxRightTop' : { 
  'position' : 'absolute',
  'background-image' : `url( ${loginBoxRightTop})`,
  'top' : '7px',
  'right' : '7px',
  'width' : '46px',
  'height' : '46px'
 
},
 'loginBoxLeftBottom' : { 
  'position' : 'absolute',
  'background-image' : `url( ${loginBoxLeftBottom})`,
  'bottom' : '7px',
  'left' : '7px',
  'width' : '46px',
  'height' : '46px'
 
},
 'loginBoxRightBottom' : { 
  'position' : 'absolute',
  'background-image' : `url( ${loginBoxRightBottom})`,
  'bottom' : '7px',
  'right' : '7px',
  'width' : '46px',
  'height' : '46px'
 
},
 'discountTipsIconBg' : { 
  'background-color' : '#f65555',
  'transform' : 'skew(-30deg)'
 
},
 'discountTipsIcon' : { 
  'position' : 'absolute',
  'top' : '-3px',
  'left' : '-3px',
  'background' : '#f3f3f3',
  'height' : '19px',
  'width' : '19px',
  'border-radius' : '0 0 17px 0'
 
},
 'thirdPartNameIconLeft' : { 
  'display' : 'inline-block',
  'background-image' : 'url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAaCAYAAADxNd/XAAAFa0lEQVRYhc1Ya2zTVRT/3ft/tPvz77qu7da96NgGg8FgY7AF0AAuKAgRQQ2Jrw8maoyRSOKMRgmKH0iUABIDgWAEgokRI4FEMHEaESM4INsYKOzFQDa2dt2j7dr+n9cPqwrLNuY6nL/kfLgn59xzzr3nnPsgh/LtOwHMAXAdwEsA9gOYhv8fngHgG8rkbfmFFbyhZVukKc7+thbQtIwFFgIXR+kk+DgykvNnuJu/O+kzGbuLz+euXldHVcUvSFIguP9jTFu9vo43DSchk+TpCLDlzQg3VZ8CGxIAYYyVALADGDg8K+3C87/7FgCYMhlO3gO/flrgiDEMCWBfvn2S/JkY8Obk2C0A8AWATgBrAPwIQB5B1gVAjMtqGGw2BwBUAwDPRtC6n0ibV1YcaKgrS3GkRnUlhlA0uiRZkniC4QuPUAoCZJjMBBjKDdPcEFVimzRd28UbIyjdT2Q/8FCUUL491emKdl04B9e8olvJVkkgw3SOaLfPFvV32cAYSc7J6zE1jUa6bqcIFuuO8ED4W974z90HcitXXclZsvwwx/PhtrM/YUXVlkM8oeJwaxm+3eFt2LdrZayzI5VRrt/72OP1jUePVGq9AVuKJ6tqUmogfe782wB2AjD7o1FkLVz8CTB8KqQDjtbT1ZnB9j+WxYL9cvGLr227cf6sNxLwl4q8sGxSdmB7gUMH4L9j3D2KuD9v+cNNEVVdJhFKD87Pq0maNftWVNNKZVG08mwSauDfovNyfSljDKLdEWJ+n9TZUFduYQxWd3pgolKIAngSwCoAmfExACQByBjCAwAWp7GAC/l9gsNmhxIOihpj15RIJD3Fna5lLl56eiJSKAPAMQAVVsECqyCC3nGPIoSAoxSUUOCuLsPGHgIZbLBhvz8ThCAtPUvNKFt4PX/NuoOJBmClHF9NTLPIlerWHVk5/bw1SYsG/HK0JyADAOV5g5ksgZshA6HUlNzpQSFJ0qgoGvYcb9ecZ184Insy63kzgRrgBPF1Q1OLPO4MzbvowaasisW1sWDQOLdnx3M8xyHVm9edVlzSzomiyYni32tl6joFY2MyrEUGRLs3r8c+NbfF0DXFmuIIZS1cdJEThFMfTHfrCZ3EnCi+auU4pM2c3b7kzc27ZU/mL3tXVLwdjkVIdm5BqHxj1Ve5Syu/x+AVQLtTFXfXxGhIAtAOoCM+jgDofK/AyQAgoRRSFMVjk5KRt+LRk7In89CWAlcsyeks53kRjukzW3KXVm7bWph+UzP0BKyMjoS6EAEIoRS6qh7fOjMjpoMBHGfjeQGEFxo/mpt7U7mPzgMANQCMl3hZVkwQ1H/5eYlqGjAAWOyOMCMUvsarXtU0xz33WImaAMZLzmkF7TpjGOjt2SwIlhkmgOySsssaYwj6usp5XlibyPxjoYRO4tK1T31Ts3/Py0Y0JidLttqYph70tbb0QJIiTNUlq2A9ZhGsNTFNuQLgfNzmaGgG8AOAp/HP++AEBt8Cw4JsyneOO4APf+soPP7+W5911dQUK329MmMMA2oUhmlCtiSBoxwAQNU1aIYO1dBGnc9qSz4d6utdpoMFLJRLpYTAkT31iY7Wpq8NNnzsCRUxL4qNK6ve3f7zgb2v+BouzVL7+iRZ0zjGGDFUlddjMcE0dCJSjtpTHAOE0lG7tux2y22XamGmJOtOixziKEVm8TyX70YbNF2Z+AA2FrjY7ubuE4+88U7fzbqLy9vrawuVcEhmhkkpx/GGokjBjvYUJRK2eAqLWhklo3ZtyeG80lx/EeXrN5yxgsqEELjypl87c+LoiLlHhn5TJAAnAC8GfzT+OqQsADxx3lXcuwa64nIVAKxxXh2A/pEU/gTpFWa7D2WMrAAAAABJRU5ErkJggg==);',
  'width' : '48px',
  'height' : '26px',
  'background-size' : 'contain'
 
},
 'thirdPartNameIconRight' : { 
  'display' : 'inline-block',
  'background-image' : 'url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAaCAYAAADxNd/XAAAFh0lEQVRYhc2YeWwUVRzHv3Pv7Ox2rx60224rLVehHDXFqgRBDpHQoBg0YoIBE6OoMZEjJBrQP1TSxmgTkGBiRfkHDQliAmiCgYLhEgyEcLWld2lLt8duZ7ezM/Pe+Ecrh5Rt3R7xk7xk3nuZ3/y+b37v93szzPe5LsThGQBrBq5rAJQB2AwgL95NAJwAngAQBFAFIDowbgJoBHAIwI0hbAwLpiKOAGdWzi6ttXmDJIoQHM5GLRzKNnmhgTeNAMey8Q0zDHieh0UpCKWwLOvuHKGU6rq+i1D6wYCohOGtOJO+gjlWVFGCsiRBcHnU4KU/4cidqkqmHowngBoGp3V2OCxishYhHAdA8iargsMZMyKqGOsKOuyy/J5mGA5VVdePSACNM5mz/MXjRqjbwXMcOMl2+/bFc5jx6rpDLDEzGIZ5tADTlKJtLYG+liZP9/UrGVp7q0sL9diyV689YkRVV/DC2enhm9f8osCss9uVvWo0cjJRAcyeOCH0Zk2PB0D6QDdaMSW5fv3NYA4A+xB2OQBpANJvHdz//NXyz14gEVX2TJ9VtmDvwcNt508vufDxxreNjnavmOT+7U5L4zLDTCySmN3xN/GIeaumZ9rPqxYdMRpqc5R0/6mOupr5r19tSzmxZcOP7ccOL5Rdni61q9MXjvQmZJ+1AIxl253nvk5Ztt0gJlhR8vG8gN157g5GEM5qug4LkDieT9g+T/DoWB4tuhrqMkUKiN7kXqu2BgQMms6fTtcJBSsrmhUOI1E/WAJgjNv7ke5OPydKNLlw7lmDEhBgcndj/SsszyMpb3KDaVkJ278/C8kAFgLwA2DQX8SyAWj3CaYA9GEuDgfAB6DILslw+rN6Om9cbeozjG2UYTYyliW70jKiWUtWHKw+cQzxsmE8mLJcNwDMA8McYCykiYKAf3K8yPdf31eDAAAW4lWPB2EZFgLPAwAMYiLS1wee4+CdkBEJLFx6qfjDT9eUT0lpNEhiWYi3wGQyLHtUYFlHsi9NF2w2MxYODZUmhwXDcpThWIsVBJPlBSoClnOCZMoeXyRl9uNVM994p/zrGf5GnRAgwT3A84pjmxmNOlIzAn0ZxfOq7lz+y2/0dNslu2JILneEFcUH3q5FyLCexHAcdQVyumRfigqO0y1KKMsLRExyhVNmzKoKzF/0K4Dfe7W+hBy/K4CybIks2+GdVlD39PYdpRUL5uyBZSF/5eqLxZs+qsTDMR//EHQPCqABQBfunXdMAL0A6kqnpLaYCYbNAwII4BR4Ec5A9mlesu3v6g1VeCUFgsN54Mvp/i/U2MhWaKzhebsjZmm60nzujKs0P4OydsWwwEoNJ48rGjFBx6FOjARu7dJnX9ZaWzJ0VZ1KCNVEr7eQ1WJOvTdUGDP0JoOYaQAmDtJSATQDWDzQbwQSzoYJw1z+5cDWM+VlW61QyAUA4T4VNkGCyAugFkUoqoLQh/3iRLHOjMUm6sSwJF6EN/BYalvtzY7hJ9jRgZ9Z8tK+zvrap26fqpyr93QrvqQkztQ0gZqE4wWbmepyD7rTBJtd6WltQZghfenuZASKnlRa66o66L+LxlgL2Jrna9lR0/n5tUlTX2u/cjmfaJqNASOFmho8sserik6nOljdEh2Ozgv7vsW050ouuWUnMouKVfLTD6D/ociNBszmXC8AoLSmMwf937oy+o8BfgA9AMKPuDf8SX5m5fZrzSUD/aNb8pJNjLeATbm+cX3gaMOTwccLALw7rp4MjysAdgL4Cv2RUjnoN3FWweyi3pbmFYqkjKt3QyEpjryOprqdliKvTBIVUfF4XYMKKCxZFQzWVFfbRdu4OxkP2e259cd332DS4uXVTtEmJqVOqGeswdNeKvp/TP3faAdwHsAyAAKA+r8BuFx5a3gAeTYAAAAASUVORK5CYII=);',
  'width' : '48px',
  'height' : '26px',
  'background-size' : 'contain'
 
},
 'supportReturnGameHelmet' : { 
  'display' : 'none'
 
},
 'submitBtnCheck' : { 
  'display' : 'inline-block',
  'background-image' : `url( ${tinyCheckIcon})`,
  'width' : '26px',
  'height' : '20px'
 
},
 'serviceInput' : { 
  'background-image' : 'url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAALCAYAAAByF90EAAAA+klEQVQokZXSLUtDURgH8N+9Gwsa/CR+gcGyC5axosmXsqKCxbK6MAwDxYFFEIOIYcW2rHVxTZPNNMOCIBruszEu1zH/cLjwfzvnOecmL9enmzjHDib+hw084KyMPmp4Qh3TFUvWIlPDeooDvAcxQGWFkkp4a5HdT/GKLXzE9x6lJSWl8Mwz1VbvLQ1xHGNN0MQNkoKSJLRmeOvVVm8M6YJphG3ZHe3hsqDoIrRpeEczIc0Zn9HAF47QWdA6OA6tEd45ygW7DrGLR7TxGXwb36EN86GiIrIXOcQtusH9BDcoCuRHW8SdbJQk1klwhfjrRDP0ZX9vgqtlxl+OdzT/RJk2AgAAAABJRU5ErkJggg==);',
  'width' : '18px',
  'height' : '11px',
  'background-size' : 'contain'
 
},
 'select' : { 
  'background-image' : 'url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA0AAAAICAYAAAAiJnXPAAAAxUlEQVQYlYXPITNEUQAF4O9tEBRJQ1V0MzduoCCRtil3dobgJesHIN2yxS0igYRC2ObN6IquSYqgXOWtWYzZU8/5wqkezw4GKCGmU1PS5PoQVQeLOGly3Z8C+jjGUgf7uMCwyXXvH9DDEJfYq0opmlzP4Brr2Akx3UyALVzhHtshps+qlDIuZ3GHVWyGmEZNrru4xRM2Qkwf8I1aOIcHLOOo/fCCtRDT+3j3A7VwHiOs4BndENPb5OYPauECzrEbYnr93X8B4rZLo/fF1nsAAAAASUVORK5CYII=);',
  'width' : '18px',
  'height' : '11px',
  'background-size' : 'contain'
 
},
 'selectvh' : { 
  'background-image' : 'url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA0AAAAICAYAAAAiJnXPAAAAxUlEQVQYlYXPITNEUQAF4O9tEBRJQ1V0MzduoCCRtil3dobgJesHIN2yxS0igYRC2ObN6IquSYqgXOWtWYzZU8/5wqkezw4GKCGmU1PS5PoQVQeLOGly3Z8C+jjGUgf7uMCwyXXvH9DDEJfYq0opmlzP4Brr2Akx3UyALVzhHtshps+qlDIuZ3GHVWyGmEZNrru4xRM2Qkwf8I1aOIcHLOOo/fCCtRDT+3j3A7VwHiOs4BndENPb5OYPauECzrEbYnr93X8B4rZLo/fF1nsAAAAASUVORK5CYII=);',
  'width' : '1.3vh',
  'height' : '0.8vh',
  'background-size' : 'contain',
  'background-repeat' : 'no-repeat'
 
},
 'quession' : { 
  'background-image' : 'url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACcAAAAnCAYAAACMo1E1AAAFDUlEQVRYhbXYX6gd1RXH8c86niZBJDFeSa0mD8GWapKHIFxu0yTXP8GEPqiBFqq+RY1IIoqiL/7pg219UNGoGBWffBH6GCxBE/KgcHPba0qDGq1QkWBok6sS/5QmRsP2YeacmTln5vxBXYfNnZm79m++s/bae6+ZOP7Px9Vaqr+cWSzFNbgKq/BLnIcl+AL/wwd4T/IGDuBkjwb46RX3Nt6lPRiiEMltC+7Ab7Cw4lboLMnbJdkDxJ34Gq/heewz5NE71qpC1DWwDnN4TbJVslDKb9Fpg/svxA054N8l64p+A+EqIoVlnRdJnpPMSCZHgGjSIUWnTRIzIZ4LsWgIXE8EikisIGaJHUSMDlEBUfwqjxLYgdn5fzy1ohmuPhqXYwZrx4eIIfGMcr+1UszMH9p1eT1cv8Ry7JOs+AEhSq3PcQX2zR96enk/XDUSi6R4VYrlPwJEtU+5pVgueXX+racrOdiW3zy3J9QNZRei7+LXeBNv45NMzzJMYZJoVbwHA6/N739n98qJQ092jn+FgwhpQOIX9hIezKB6/DOIlXgUN/ZADNJMWL9s8q5ZaOXDEFI8k/8d0DcQidhJ3E58kg/hQskaySpJO3f+iLiJeKhxyemfXCHFU51/d8K+GZM9EHryoiP0omR3fnwOHiE+Jd4hjhAniLuz5Qf8GS/XTa4G6Kn5uWevzeECcUcNRM+6B3GK+ENJ9AniYdm+2onGBZJdUvyxBPIAcbZ5SAvISCFS7IA4MbdrKY5jQdW51vZgaw5xGY70JX1hZ2UFwYf5+Qzx6+4dBm9dZ4iLWsQmYsGIefG30pD8bgAY4hzi6jwSIsXRSHnGVsBqt8MF2NTGdBei0qHWbsd6HJWVS13fhkh8U9L8SfOD1N5/ui3FmoGdqh1WSlYOX2gC/i8rj8gm3lQDRJOtaePnNcLZ0Xi1XtmSZDv+m/tdL9umRrDoKFzaJpZ8D4i6SJzFNrySX1yG3QMgmuz8diSLR4KoB+m107IdYU9+vpT4K342ZsUNi9vEl5QBR4KoE/8Wv8XevP+ELOeuGAJRtdT1+rIt+SKDGxmiTyi3P2Fvfnwx9hOrhoFEM/DnbeLfGpN1aF50/D7FY/nJubKIFWCDIZo0P2zh3erW1VOTDV8w4XWcki2w2yPF6tLiW6oIayHU39+RlhRvjgFRRKLbQqT4Vwni6qEQagKQ+vzeaBMHcEZlby0gOu5DhuSzEsRFdRrNwLV2BgfasjfxvZKt4+VFxe9mqVtB/2IMiKp1X7bsvXDDbSfbkRWXL+hUG8NA6iOxIWtjQzTZbnSr1n14iygKzvGG4z+yBRjOxwUjQtTpzl244db9dIrNFEmKuyWpITl7Wp/9XopL8/Z4tdJtgigVmJ1fkiK5p+PVKoHMEruHQDS8Bo4NUWmlrwzPT2y89WABVwW5H4cziAaQRqsDaYSoa4dxX1mx3ZMXp3AdZmVv/g0QfWd/kSo5V+s7wI7huomNt5yqwvULHMNm4nWlba3rVTtR4uJRKSpqmdbH2DIxve1Yr1erIS/ej2R9JIerQzLyBClBDNwWD2PjxPS29+t6twYk58fEunySpO8J0Wsp1103Mb3taJNqX+R6onEaO2UvNXNdkNEh6rTniA257ummXjncANECYFaKKSk2S/bIPuAMgyg/5BlZdbxFMiU5OMpn12JCjPQJ2X5iP5ZiE67EasXX9MX4Cl9JPsAROl/T42S9ZLN9BxOS1vvPeJq/AAAAAElFTkSuQmCC)',
  'width' : '40px',
  'height' : '40px'
 
},
 'quessionList' : { 
  'background-image' : 'url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeCAYAAAA7MK6iAAADkklEQVRIiaWXW6gWVRTHf8rRvJBQipZdHjx0ES21wMs2TaIXsSI1LwQqkuY2KRo9EKhIgQlqtTOOOBQWqZRRZpZK4IN4aby/eLKyKFLrKBr2YoqWGgv+I+PnfDNzasGwZu1vr/1fa8/a/72+dt+sepmKMhB4DLgXaAR6yO008DNwFPja+XC0ynINFeZMBTwwrMqCSRxtB5qdD58XzSvKeAiwChgk+yywFdgFtAB/arw78CDwKPAk0EXjO4Hn6+1APeAXgXf0/guwFHgf+Kd2ovMhm21nYCYwH+il4cnOh09q/drngC7OgC4D7gHezQPNCeKC88F8+8jHZH0SR3PKgJuABWmkwCvAlTLAnADOOx9maedMmpM4Gl8P+CFgud4nAjdsz38IoBlIv+VnSRzdngf8hbRt9af/FzQDvgL4SOa1ZNLimgG8p0JqLFlrEjANGCD7O+BD58O6Iqckjs4DVnwjnA+704xfk36pBHSNFQswGuit53FgbRJHG0p809pZgrZ6uBb4DdhS4DhFj4mBDNVZX6OxcUkcvVDgn1b5iCSObjHgMRrYWBLxG9JGCM8A+4D9zodpmfqoy0bOh78yGE8YcF8ZRdm2A34A/rbvmfP7l9K3lgS/U3pUg+gOLVxProoSbwPO5cxJCWJ/CfDv0r0a9H1NLpY4mZyqsbsmcbQNeFj2vBL/M9J3NCiDTkCHCsBZscvgEHCfxp52Pnxf4pMm18W+cauMm9oIvC4DOtH5sKmCT3fpkwb8o4z72wBq1DdW73OdD1WZ7k7pVgNOt2dMgUOtPJCxP26D3yPSO9rrcjd5qg0LtOp+/gC4VMUhiaOOunxMNlpx7QVOAHcp66LznMq3wNvAZefD2YrBPqcCPuh8OF3L1SsqLmJUeRg4ksTR4Io+S6WtO7l2La4WVzdmgiiSbDdS2igkcWSf5WbggPNhGzX38TjpRRUK7ZAYr6/z4WAJqLHadJkT0vEs8AG1OiabKxRbSwnNGuhsa3tkPut8OJb+VttXW3PXU9RnhPA6sLAkgDxAY8K3gNkaanI+XHfs8hr6JnHycl3eRhSvAtagXy4B7KYOZbESMJnqfFhbO7eooR8JrAT6y/5DPdNhtUjHdTzuVjs7SI1CR823xn+O86Elb/GivzB2dxpD2fmzXTBKvaE/zpE9wJvOh8JWqMp/Jztq9lgQVvn9lKEdPdv6n4BfjRiAr5wPKffXF+Bfn1PrtBc/froAAAAASUVORK5CYII=);',
  'width' : '30px',
  'height' : '30px'
 
},
 'selectList' : { 
  'background-image' : 'url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAsAAAASCAYAAACNdSR1AAABLUlEQVQokYXSoUtdYRQA8N/Ti8FiMgj+AYO1xY9XBH0rGl4YrAjbyldmeDcIYjWYPhmieMEgrAwMhoUxw8LmPthfYDWZLM9gEOQZ3hXEd9/bqed3DudwTuvvUe81jrAeYroyIaawhzb+5Kp89T/8DhdYxO9clW/G4hBTH29xjnn8ylXZHtdZiOkOazjDHH7mquw04rrgvh7pBLP4nquy24jrggd8wj5mcJqrcv0p3xoMBo3L5KrcwTYG+BxiOhyL64JN7KKFramxcjSmiwldX45xMIJzVbbwBRt4wMcQ01coXsBpHOMD7vE+xHT2lC+ewRl8Qxd36IaYzp83K2o4a3i9DvpYDTFdjGzYWbidww8s4QYrIaZ/TUsXODV80Wssh5gumyDDc/eQ0Z4E4RF8tV8BWo5XWgAAAABJRU5ErkJggg==)',
  'width' : '11px',
  'height' : '18px'
 
},
 'quessionSelect' : { 
  'border-top-color' : $middleBrown
 
},
 'selectThirPay' : { 
  'background-image' : `url( ${selectThirPay})`,
  ...$storePayBtn
 
},
 'selectInnerPay' : { 
  'background-image' : `url( ${selectInnerPay})`,
  ...$storePayBtn
 
},
 'selectTrigger' : { 
  'width' : '13px',
  'height' : '8px',
  'border' : 'none',
  'background-image' : `url( ${triangleDown})`
 
},
 'more' : { 
  'background-image' : `url( ${more})`
 
},
 'before' : { 
  'border-right-color' : '#edd075'
 
},
 'global' : { 
  'background-image' : `url( ${whiteMall})`
 
},
 'shoppingCar' : { 
  'background-image' : `url( ${cloudShopingCar})`,
  'border-top' : '0'
 
},
 'whiteMoney' : { 
  ...$noRpBg(cloudMoney)
 
},
 'storesuccess' : { 
  'background-image' : `url( ${paySuccess})`,
  'background-repeat' : 'no-repeat'
 
},
 'storefail' : { 
  'background-image' : `url( ${payFail})`,
  'background-repeat' : 'no-repeat'
 
},
 'storestoring' : { 
  'background-image' : `url( ${payStoring})`,
  'background-repeat' : 'no-repeat'
 
},
 'playGame' : { 
  'background-image' : `url( ${playGameIcon})`,
  'background-repeat' : 'no-repeat',
  'width' : '37px',
  'height' : '33px',
  'margin-right' : '10px'
 
},
 'service' : { 
  'background-image' : `url( ${serviceIcon})`,
  'background-repeat' : 'no-repeat',
  'width' : '30px',
  'height' : '36px',
  'margin-right' : '10px'
 
},
 'switch' : { 
  'background-image' : `url( ${switchIcon})`,
  'background-repeat' : 'no-repeat',
  'width' : '22px',
  'height' : '16px'
 
},
 'bindIcon' : { 
  'background-image' : `url( ${bindIcon})`,
  ...$passportFunctionIconStyles
 
},
 'userIcon' : { 
  'background-image' : `url( ${userIcon})`,
  ...$passportFunctionIconStyles
 
},
 'ellipsisIcon' : { 
  'background-image' : `url( ${ellipsisIcon})`,
  ...$passportFunctionIconStyles
 
},
 'textIcon' : { 
  'background-image' : `url( ${textIcon})`,
  ...$passportFunctionIconStyles
 
},
 'accountFollowIcon' : { 
  'background-image' : `url( ${accountFollowIcon})`,
  ...$passportFunctionIconStyles
 
},
 'exchangeIcon' : { 
  'background-image' : `url( ${exchangeIcon})`,
  ...$passportFunctionIconStyles
 
},
 'fundTermsIcon' : { 
  'background-image' : `url( ${fundTermsIcon})`,
  ...$passportFunctionIconStyles
 
},
 'survey' : { 
  'background-image' : `url( ${survey})`,
  ...$passportFunctionIconStyles
 
},
 'deleteIcon' : { 
  'background-image' : `url( ${deleteIcon})`,
  ...$passportFunctionIconStyles
 
},
 'settingIcon' : { 
  'background-image' : `url( ${deleteIcon})`,
  ...$passportFunctionIconStyles
 
},
 'selectHili' : { 
  'background-image' : `url( ${selectHili})`,
  'background-repeat' : 'no-repeat',
  'width' : '14px',
  'height' : '26px',
  'margin-right' : '0'
 
},
 'userName' : { 
  'background-image' : `url( ${userName})`,
  'width' : '2.8vh',
  'height' : '3.3vh',
  'background-repeat' : 'no-repeat',
  'background-size' : 'cover'
 
},
 'password' : { 
  'background-image' : `url( ${password})`,
  'width' : '2.7vh',
  'height' : '2.9vh',
  'background-repeat' : 'no-repeat',
  'background-size' : 'cover'
 
},
 'helmet' : { 
  'display' : 'none'
 
},
 'folder' : { 
  'display' : 'none'
 
},
 'service' : { 
  'background-image' : `url( ${serviceIcon})`,
  'width' : '30px',
  'height' : '36px'
 
},
 'serviceDefaultAvatar' : { 
  'background-image' : `url( ${serviceDefaultAvatar})`
 
},
 'userDefaultAvatar' : { 
  'background-image' : `url( ${userDefaultAvatar})`
 
},
 'userInfoDefaultAvatar' : { 
  'background-image' : `url( ${userInfoDefaultAvatar})`
 
},
 'line' : { 
  'background-color' : '#9dc8f3'
 
},
 'custom' : { 
  'color' : '#9dc8f3'
 
},
 'showChildpayTypeIcon' : { 
  'background-image' : `url( ${more})`
 
},
 'storeBtnLeft' : { 
  'display' : 'inline-block',
  'position' : 'absolute',
  'left' : '15px',
  'top' : '179px',
  'height' : '78px',
  'width' : '33px',
  'background-image' : `url( ${leftImg})`
 
},
 'storeBtnRight' : { 
  'display' : 'inline-block',
  'position' : 'absolute',
  'right' : '15px',
  'top' : '179px',
  'height' : '78px',
  'width' : '33px',
  'background-image' : `url( ${rightImg})`
 
},
 'reStoreBtnLeft' : { 
  'display' : 'inline-block',
  'position' : 'absolute',
  'left' : '11px',
  'top' : '0',
  'height' : '86px',
  'width' : '40px',
  'background-image' : `url( ${restoreLeftImg})`
 
},
 'reStoreBtnRight' : { 
  'display' : 'inline-block',
  'position' : 'absolute',
  'right' : '11px',
  'top' : '0',
  'height' : '86px',
  'width' : '40px',
  'background-image' : `url( ${restoreRightImg})`
 
},
 'returnGameBtnLeft' : { 
  'display' : 'inline-block',
  'position' : 'absolute',
  'left' : '11px',
  'top' : '116px',
  'height' : '86px',
  'width' : '40px',
  'background-image' : `url( ${returnGameLeftImg})`
 
},
 'returnGameBtnRight' : { 
  'display' : 'inline-block',
  'position' : 'absolute',
  'right' : '11px',
  'top' : '116px',
  'height' : '86px',
  'width' : '40px',
  'background-image' : `url( ${returnGameRightImg})`
 
},
 'switchBtnLeft' : { 
  'display' : 'inline-block',
  'position' : 'absolute',
  'left' : '-25px',
  'top' : '0px',
  'height' : '60px',
  'width' : '26px',
  'background-image' : `url( ${switchAccountLeftImg})`
 
},
 'switchBtnRight' : { 
  'display' : 'inline-block',
  'position' : 'absolute',
  'right' : '-25px',
  'top' : '0px',
  'height' : '60px',
  'width' : '26px',
  'background-image' : `url( ${switchAccountRightImg})`
 
},
 'commonBtnLeft' : { 
  'display' : 'inline-block',
  'position' : 'absolute',
  'left' : '-25px',
  'top' : '0px',
  'height' : '60px',
  'width' : '26px',
  'background-image' : `url( ${commonBtnLeftImg})`
 
},
 'commonBtnRight' : { 
  'display' : 'inline-block',
  'position' : 'absolute',
  'right' : '-25px',
  'top' : '0px',
  'height' : '60px',
  'width' : '26px',
  'background-image' : `url( ${commonBtnRightImg})`
 
},
 'createWorkBtnLeft' : { 
  'display' : 'inline-block',
  'position' : 'absolute',
  'left' : '11px',
  'top' : '0',
  'height' : '78px',
  'width' : '34px',
  'background-image' : `url( ${createWorkLeftImg})`
 
},
 'createWorkBtnRight' : { 
  'display' : 'inline-block',
  'position' : 'absolute',
  'right' : '11px',
  'top' : '0',
  'height' : '78px',
  'width' : '34px',
  'background-image' : `url( ${createWorkRightImg})`
 
},
 'resultBackBtnLeft' : { 
  'display' : 'inline-block',
  'position' : 'absolute',
  'left' : '-29px',
  'top' : '0',
  'height' : '60px',
  'width' : '30px',
  'background-image' : `url( ${resultBackLeftImg})`
 
},
 'resultBackBtnRight' : { 
  'display' : 'inline-block',
  'position' : 'absolute',
  'right' : '-29px',
  'top' : '0',
  'height' : '60px',
  'width' : '30px',
  'background-image' : `url( ${resultBackRightImg})`
 
},
 'resultHistoryBtnLeft' : { 
  'display' : 'inline-block',
  'position' : 'absolute',
  'left' : '-29px',
  'top' : '0',
  'height' : '60px',
  'width' : '30px',
  'background-image' : `url( ${resultHistoryLeftImg})`
 
},
 'resultHistoryBtnRight' : { 
  'display' : 'inline-block',
  'position' : 'absolute',
  'right' : '-29px',
  'top' : '0',
  'height' : '60px',
  'width' : '30px',
  'background-image' : `url( ${resultHistoryRightImg})`
 
},
 'loginBtnLeft' : { 
  'display' : 'inline-block',
  'position' : 'absolute',
  'left' : '-26px',
  'top' : '0',
  'height' : '60px',
  'width' : '27px',
  'background-image' : `url( ${loginBtnLeftImg})`
 
},
 'loginBtnRight' : { 
  'display' : 'inline-block',
  'position' : 'absolute',
  'right' : '-26px',
  'top' : '0',
  'height' : '60px',
  'width' : '27px',
  'background-image' : `url( ${loginBtnRightImg})`
 
},
 'loginBtnLeft2' : { 
  'display' : 'inline-block',
  'position' : 'absolute',
  'left' : '-26px',
  'top' : '0',
  'height' : '60px',
  'width' : '27px',
  'background-image' : `url( ${loginBtnLeftImg2})`
 
},
 'loginBtnRight2' : { 
  'display' : 'inline-block',
  'position' : 'absolute',
  'right' : '-26px',
  'top' : '0',
  'height' : '60px',
  'width' : '27px',
  'background-image' : `url( ${loginBtnRightImg2})`
 
}} 
}
,
'payState' : { 

 typeTheme :{ 
 'success' : { 
  'background-image' : `url( ${paySuccessBg})`
 
},
 'fail' : { 
  'background-image' : `url( ${payFailBg})`
 
}} 
}
,
'listItem' : { 
  commonTheme : {
  'border' : '1px solid #e4d8cf',
  'color' : '#a49b94',
  'border-width' : '2px'
  },
 typeTheme :{ 
 'active' : { 
  'border' : '1px solid #c59871',
  'color' : '#a17449',
  'border-width' : '2px'
 
},
 'selectItem' : { 
  'border' : '1px solid #e4d8cf',
  'padding-left' : '70px'
 
},
 'selectItem-active' : { 
  'border-color' : '#c59871'
 
},
 'functionItem' : { 
  'padding-right' : '48px',
  'padding-left' : '76px',
  'background' : 'transparent',
  'display' : 'flex',
  'align-items' : 'center',
  'color' : '#5a3823',
  'border' : 'none'
 
},
 'accountSettingItem' : { 
  'padding-right' : '48px',
  'padding-left' : '26px',
  'background' : 'transparent',
  'display' : 'flex',
  'align-items' : 'center',
  'border' : 'none'
 
},
 'locationItem' : { 
  'height' : '80px',
  'border' : '1px solid #e4d8cf',
  'color' : '#a49b94'
 
},
 'productSelectOptions' : { 
  'text-align' : 'left'
 
},
 'paymentItem' : { 
  'height' : '80px'
 
}} 
}
,
'thirPartPay' : { 
  commonTheme : {
  'background-image' : `url( ${thirPartPayBg})`,
  'border-radius' : '0',
  'width' : '688px',
  'background-repeat' : 'no-repeat'
  }}
,
'innerPay' : { 
  commonTheme : {
  'background-image' : `url( ${thirPartPayBg2})`,
  'border-radius' : '0',
  'width' : '688px',
  'height' : '325px',
  'background-color' : 'transparent',
  'background-repeat' : 'no-repeat',
  'border' : 'none',
  'margin-top' : '-3px'
  },
 typeTheme :{ 
 'oneStore' : { 
  'background' : 'black'
 
}} 
}
,
'list' : { 

 typeTheme :{ 
 'passportFunctionList' : { 
  'display' : 'inline-block',
  'padding' : '76px 0 76px 0',
  'background' : 'white',
  'border-radius' : '12px',
  'box-sizing' : 'border-box',
  'margin-top' : '-62px',
  'margin-bottom' : '20px'
 
}} 
}
,
'editor' : { 
  commonTheme : {
  'color' : $inputCorlor
  },
 typeTheme :{ 
 'passportAccountEditor' : { 
  'background' : 'transparent'
 
},
 'loginEditor' : { 
  'color' : '#5a3823 !important',
  'border' : 'none',
  'background-image' : `url( ${inputBg})`,
  'width' : '45.6vh',
  'height' : '6.4vh',
  'background-size' : '99.9% 100%',
  'background-repeat' : 'no-repeat'
 
}} 
}
,
'scoreStart' : { 
  commonTheme : {
  'background-image' : `url( ${cloudStar})`,
  'background-repeat' : 'no-repeat'
  },
 typeTheme :{ 
 'active' : { 
  'background-image' : `url( ${cloudStarActive})`,
  'background-repeat' : 'no-repeat'
 
}} 
}
,
'storeLogo' : { 
  commonTheme : {
  'margin-top' : '6px',
  'margin-bottom' : '-35px'
  },
 typeTheme :{ 
 'passportIco' : { 
  'margin-top' : '0',
  'margin-bottom' : '0'
 
}} 
}
,
'typeCategory' : { 
  commonTheme : {
  'color' : $middleBrown
  }}
,
'bankText' : { 
  commonTheme : {
  'color' : $middleBrown
  }}
,
'bankTotal' : { 
  commonTheme : {
  'border-color' : '#c59871'
  }}

}